"use client";

import React, { useEffect, useRef } from "react";
import { useTranslations } from "next-intl";
import Image from "next/image";
import CusTitle from "@/components/Home2/CusTitle";
import "animate.css";
import GetQuteTip from "@/components/Service/CNC/GetQuteTip.tsx";
import { Swiper, SwiperSlide } from "swiper/react";
type testimonials = {
	banner: string;
	name: string;
	company: string;
	content: string;
};
const Testimonials = ({
	className,
	tList,
	dsc,
	tip,
}: {
	className?: string;
	tList?: testimonials[];
	dsc?: string;
	tip?: string;
}) => {
	const t = useTranslations();
	const list = [
		{
			banner: "/image/home/customerTestimonials/John Doe.png",
			name: "testimonials.name1",
			company: "testimonials.company1",
			content: "testimonials.t1",
		},
		{
			banner: "/image/home/customerTestimonials/Jane Smith.png",
			name: "testimonials.name2",
			company: "testimonials.company2",
			content: "testimonials.t2",
		},
		{
			banner: "/image/home/customerTestimonials/Michael Brown.png",
			name: "testimonials.name3",
			company: "testimonials.company3",
			content: "testimonials.t3",
		},
	];

	const refs = useRef<(HTMLLIElement | null)[]>([]);

	useEffect(() => {
		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						entry.target.classList.add("animate__animated", "animate__fadeInUp");
						observer.unobserve(entry.target);
					}
				});
			},
			{ threshold: 0.2 },
		);

		refs.current.forEach((ref) => {
			if (ref) {
				observer.observe(ref);
			}
		});

		return () => {
			refs.current.forEach((ref) => {
				if (ref) observer.unobserve(ref);
			});
		};
	}, []);

	return (
		<div className={`${className} py-8 sm:py-10 md:py-12 lg:py-16`}>
			<div className="container text-center">
				<h2 className="mb-3 text-2xl font-bold leading-tight text-black sm:mb-4 sm:text-[30px] md:text-4xl">
					{t("testimonials.CustomerTestimonials")}
				</h2>
				<div className="flex justify-center text-center">
					<p className="mb-4 text-sm leading-relaxed text-black md:text-base">
						{t(dsc || "testimonials.Dicover")}
					</p>
				</div>
				<div
					className="trustpilot-widget mt-10"
					data-locale="en-GB"
					data-template-id="53aa8912dec7e10d38f59f36"
					data-businessunit-id="68808142dd0a4c4d3e411b9c"
					data-style-height="140px"
					data-style-width="100%"
					data-token="641f8116-607b-46db-8dbe-580350245132"
					data-stars="1,2,3,4,5"
					data-review-languages="en"
				>
					<a
						href="https://www.trustpilot.com/review/www.cncprotolabs.com?utm_medium=trustbox&utm_source=MicroTrustScore"
						target="_blank"
						rel="noopener"
					>
						Trustpilot
					</a>
				</div>
			</div>
			{tip && <GetQuteTip tip={t(tip)}></GetQuteTip>}
		</div>
	);
};

export default Testimonials;
